import React from "react";
import { X, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Convert, Trade } from "iconsax-reactjs";

const SelectFundingMethodModal = ({
    isOpen,
    onClose,
    onWalletOptionSelect,
    onConversionOptionSelect,
}) => {
    const navigate = useNavigate();
    if (!isOpen) return null;

    const options = [
        {
            icon: <Trade className="w-5 h-5 text-[#8C30F5]" />,
            title: "Fund via wallet address",
            subtitle: "Receive USDC via your wallet address from anywhere",
            onClick: () => {
                onClose();
                if (onWalletOptionSelect) onWalletOptionSelect();
            },
            roundedClass: "rounded-t-xl",
            disabled: false,
        },
        {
            icon: <Convert className="w-5 h-5 text-[#8C30F5]" />,
            title: "Fund via conversion",
            subtitle: "Convert funds from another wallet to USDC.",
            onClick: () => {
                // intentionally disabled for now
                // onClose();
                // if (typeof onConversionOptionSelect === "function") onConversionOptionSelect();
            },
            roundedClass: "rounded-b-xl",
            disabled: true, // deactivate
        },
    ];

    return (
        <div className="fixed inset-0 z-[600] flex items-center justify-center bg-black/30">
            <div className="bg-white w-[90%] max-w-xl rounded-2xl shadow-lg p-6 relative">
                {/* Header */}
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-semibold text-[#101828]">Fund your wallet</h2>
                    <button onClick={onClose}>
                        <X size={24} color="#101828" />
                    </button>
                </div>

                <div>
                    {options.map((option, idx) => {
                        const base =
                            "flex items-center justify-between w-full p-4 border border-[#EEF0F6] text-left transition " +
                            option.roundedClass;
                        const active = "hover:bg-[#F9FAFB] cursor-pointer";
                        const inactive = "opacity-50 cursor-not-allowed bg-white"; // subtle, like the mock

                        return (
                            <button
                                key={idx}
                                type="button"
                                disabled={option.disabled}
                                aria-disabled={option.disabled}
                                onClick={() => {
                                    if (option.disabled) return;
                                    option.onClick();
                                }}
                                className={`${base} ${option.disabled ? inactive : active}`}
                            >
                                <div className="flex items-center gap-4">
                                    <div
                                        className={`w-10 h-10 rounded-full flex items-center justify-center ${
                                            option.disabled ? "bg-[#F5F6FA]" : "bg-[#EFE8FF]"
                                        }`}
                                    >
                                        {option.icon}
                                    </div>
                                    <div>
                                        <p
                                            className={`text-[16px] font-[450] ${
                                                option.disabled
                                                    ? "text-[#98A2B3]"
                                                    : "text-[#101828]"
                                            }`}
                                        >
                                            {option.title}
                                        </p>
                                        <p
                                            className={`font-[350] text-[14px] ${
                                                option.disabled
                                                    ? "text-[#C2C8D5]"
                                                    : "text-[#6F739B]"
                                            }`}
                                        >
                                            {option.subtitle}
                                        </p>
                                    </div>
                                </div>

                                <ChevronRight
                                    size={20}
                                    className={
                                        option.disabled ? "text-[#D0D5DD]" : "text-[#101828]"
                                    }
                                />
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default SelectFundingMethodModal;
